import { createModule } from '@evyweb/ioctopus';

import { createExternalCouponWagerUseCase, createWagerUseCase, removeWagerUseCase } from '../../application/entry.js';
import { wagerClientService } from '../../infrastructure/entry.browser.js';
import {
  createExternalWagerController,
  createWagerController,
  removeWagerController,
} from '../../interface-adapters/entry.browser.js';
import { diSymbolMap } from '../types.js';

/**
 * Creates and configures the create wager module.
 *
 * @returns The configured wager module.
 */
export function wagerClientModule(): ReturnType<typeof createModule> {
  const wagerModule = createModule();

  // Services
  wagerModule
    .bind(diSymbolMap.IWagerClientService)
    .toHigherOrderFunction(wagerClientService, [diSymbolMap.IDefinitionService]);

  // Use cases
  wagerModule
    .bind(diSymbolMap.ICreateWagerUseCase)
    .toHigherOrderFunction(createWagerUseCase, [
      diSymbolMap.IWagerClientService,
      diSymbolMap.ICouponRepository,
      diSymbolMap.IDefinitionService,
    ]);
  wagerModule
    .bind(diSymbolMap.ICreateExternalCouponWagerUseCase)
    .toHigherOrderFunction(createExternalCouponWagerUseCase, [diSymbolMap.IWagerClientService]);
  wagerModule
    .bind(diSymbolMap.IRemoveWagerUseCase)
    .toHigherOrderFunction(removeWagerUseCase, [diSymbolMap.IWagerClientService]);

  // Controllers
  wagerModule
    .bind(diSymbolMap.ICreateWagerController)
    .toHigherOrderFunction(createWagerController, [
      diSymbolMap.ICreateWagerUseCase,
      diSymbolMap.IDeleteCouponUseCase,
      diSymbolMap.IDeleteCouponWalletUseCase,
      diSymbolMap.IUpdateCouponWalletUseCase,
    ]);
  wagerModule
    .bind(diSymbolMap.ICreateExternalWagerController)
    .toHigherOrderFunction(createExternalWagerController, [diSymbolMap.ICreateExternalCouponWagerUseCase]);
  wagerModule
    .bind(diSymbolMap.IRemoveWagerController)
    .toHigherOrderFunction(removeWagerController, [diSymbolMap.IRemoveWagerUseCase]);

  return wagerModule;
}
